import {RouterModule, Routes} from '@angular/router';
import {DeactivateGuard} from '../guards/deactivate.guard';
import {ReportsComponent} from './reports.component';
import {MyReportsComponent} from './myReports/myreports.component';
import {SessionLengthComponent} from './myReports/session-length/session-length.component';
import {FeaturesDurationComponent} from './myReports/features-duration/features-duration.component';
import {OpenSessionComponent} from './myReports/open-session/open-session.component';
import {ClosedSessionComponent} from './myReports/closed-session/closed-session.component';
import {SummaryComponent} from './myReports/summary/summary.component';
import {DeniedFeaturesComponent} from './myReports/denied-features/denied-features.component';
import {DeniedUsersComponent} from './myReports/denied-users/denied-users.component';
import {FeaturesComponent} from './myReports/features/features.component';
import {FeaturesNumberComponent} from './myReports/features-number/features-number.component';
import {DenialsDayComponent} from './myReports/denials-day/denials-day.component';
import {DenialReasonsComponent} from './myReports/denial-reasons/denial-reasons.component';
import {BenchmarksComponent} from './myReports/benchmarks/benchmarks.component';
import {LeastUsedFeaturesComponent} from './myReports/least-used-features/least-used-features.component';
import {UserSessionsComponent} from './myReports/user-sessions/user-sessions.component';
import {LicenseUsageComponent} from './myReports/license-usage/license-usage.component';
import {UsersComponent} from './myReports/users/users.component';
import {DenialsComponent} from './myReports/denials/denials.component';
import {ErrorsComponent} from './myReports/errors/errors.component';
import {VendorSpecificComponent} from './myReports/vendor-specific/vendor-specific.component';
import {
    AverageComponent,
    DenialFrequencyComponent,
    LicenseUserComponent,
    PercentUsageComponent,
    UserSessionComponent
} from './myReports/benchmarks/all.benchmarks.component';

import {AuthGuard} from '../guards/loggedin.guard';
import {ChartsComponent} from './myReports/charts/charts.component';

export const routes: Routes = [
  {
    path: 'reports',
    // canActivate: [ReportGuard],
    
    component: ReportsComponent,
    children: [
      {path: '', redirectTo: 'myreports', pathMatch: 'full'},
      {
        path: 'myreports',
        canDeactivate: [DeactivateGuard],
        component: MyReportsComponent,
        children: [
          {path: 'session-length', component: SessionLengthComponent},
          {path: 'features-by-duration', component: FeaturesDurationComponent},
          {path: 'features-by-number', component: FeaturesNumberComponent},
          {path: 'least-used-features', component: LeastUsedFeaturesComponent},
          {path: 'user-by-sessions', component: UserSessionsComponent},
          {path: 'denied-features', component: DeniedFeaturesComponent},
          {path: 'denied-users', component: DeniedUsersComponent},
          {path: 'denial-reasons', component: DenialReasonsComponent},
          {path: 'denials-day', component: DenialsDayComponent},
          {path: 'license-usage', component: LicenseUsageComponent},
          {
            path: 'benchmarks', component: BenchmarksComponent,
            children: [
//              {path: '', redirectTo: 'average-session', pathMatch: 'full'},
              {path: 'average-session', component: AverageComponent},
              {path: 'denial-frequency', component: DenialFrequencyComponent},
              {path: 'license-user', component: LicenseUserComponent},
              {path: 'percent-usage', component: PercentUsageComponent},
              {path: 'user-session', component: UserSessionComponent}
            ]
          },
          {path: 'charts', component: ChartsComponent},
          {path: 'users', component: UsersComponent},
          {path: 'features', component: FeaturesComponent},
          {path: 'closed-session', component: ClosedSessionComponent},
          {path: 'open-session', component: OpenSessionComponent},
          {path: 'denials', component: DenialsComponent},
          {path: 'vendor-specific', component: VendorSpecificComponent},
          {path: 'errors', component: ErrorsComponent},
          {path: 'summary', component: SummaryComponent}
        ]
      }
    ]
  },
];

export const routing = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/reports.routing.ts